export default __webpack_public_path__ + "static/media/A2.fe7dac72.jpeg";